import { AttributeInput } from '@shopify/hydrogen-react/storefront-api-types';

const ELEVAR_PARAMS_KEY = '___ELEVAR_GTM_SUITE--params';
const ELEVAR_COOKIES_KEY = '___ELEVAR_GTM_SUITE--cookies';

interface ElevarParams {
  user_id?: string;
  session_id?: string;
  session_count?: string;
  session_landing_page_url?: string;
  session_landing_page_title?: string;
}

interface ElevarCookies {
  _fbp?: string;
  _fbc?: string;
  _ga?: string;
  [key: string]: string | undefined;
}

const readJson = <T>(key: string): T | null => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

export const getElevarParams = (): ElevarParams | null => readJson<ElevarParams>(ELEVAR_PARAMS_KEY);

export const getElevarCookies = (): ElevarCookies | null =>
  readJson<ElevarCookies>(ELEVAR_COOKIES_KEY);

export const isElevarReady = (): boolean => !!getElevarParams()?.user_id;

export const getElevarCartAttributes = (): AttributeInput[] => {
  const params = getElevarParams();
  const cookies = getElevarCookies();

  const attrs: AttributeInput[] = [];

  if (params?.user_id) attrs.push({ key: '_elevar_visitor_id', value: params.user_id });
  if (params?.session_id) attrs.push({ key: '_elevar_session_id', value: params.session_id });
  if (params?.session_count)
    attrs.push({ key: '_elevar_session_count', value: params.session_count });
  if (params?.session_landing_page_url)
    attrs.push({ key: '_elevar_landing_url', value: params.session_landing_page_url });

  if (cookies?._fbp) attrs.push({ key: '_elevar_fbp', value: cookies._fbp });
  if (cookies?._fbc) attrs.push({ key: '_elevar_fbc', value: cookies._fbc });
  if (cookies?._ga) attrs.push({ key: '_elevar_ga', value: cookies._ga });

  return attrs;
};
